export default __webpack_public_path__ + "static/media/do_cennika2.103b38a2.jpg";